import React from 'react';

import AnalyticsClient from '../clients/AnalyticsClient';
import Analytics from '../context/Analytics';

export interface AnalyticsConsumerProps {
  analytics: AnalyticsClient;
}

export const withAnalytics = <OriginalProps extends {}>(
  ComponentToWrap: React.ComponentType<OriginalProps & AnalyticsConsumerProps>,
) => {
  class WrappedComponent extends React.Component<OriginalProps> {
    render() {
      return (
        <Analytics.Consumer>
          {analytics => <ComponentToWrap analytics={analytics} {...this.props} />}
        </Analytics.Consumer>
      );
    }
  }
  /**
   * This is to workaround the problem where components have no other props other than AnalyticsConsumerProps
   * Without this, TypeScript will complain about missing props, which is unnecessary,
   * because this analytics prop is injected, not passed.
   *
   * Honestly, this is probably not the best way to do it, but I'm not smart enough to figure out TypeScript.
   * This will do for now.
   */
  type MaybeType = OriginalProps extends AnalyticsConsumerProps ? {} : OriginalProps;
  return WrappedComponent as React.ComponentType<MaybeType>;
};
